<template>
  <v-row class="px-3">
    <v-col cols="6">
      <v-form ref="addEditHostDetailsForm" v-model="isValid">
        <v-row dense>
          <v-col cols="12" md="12" class="mt-1">
            <div class="text-subtitle-1 font-weight-bold">Event host</div>
          </v-col>
          <v-col
            cols="12"
            md="12"
            v-if="!isEditMode && isSuperUserDashboard"
            class="py-0"
          >
            <div class="text-body-2 font-weight-medium">Business profile</div>
          </v-col>
          <v-col
            cols="12"
            md="12"
            v-if="!isEditMode && isSuperUserDashboard"
            class="py-0"
          >
            <v-autocomplete
              v-model="currentEvent.businessProfileId"
              :items="businessProfiles"
              outlined
              dense
              item-text="businessName"
              item-value="id"
              @change="handleBusinessProfileChange($event)"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" md="12" class="pt-0">
            <div class="text-body-2 font-weight-medium">Host name</div>
          </v-col>
          <v-col cols="12" md="12" class="py-0">
            <v-text-field
              dense
              outlined
              v-model="currentEvent.hostName"
              :rules="requiredRules"
            />
          </v-col>
          <v-col cols="12" md="12" class="pt-0" v-if="this.currentEvent.eventCategory != 'travel'">
            <div class="text-body-2 font-weight-medium">
              URL to host’s website <span class="grey--text">(optional)</span>
            </div>
          </v-col>
          <v-col cols="12" md="12" class="py-0" v-if="this.currentEvent.eventCategory != 'travel'">
            <v-text-field
              dense
              outlined
              v-model="currentEvent.hostsWebsiteURL"
              placeholder="Add a URL so attendees can access information about you"
            />
          </v-col>
        </v-row>
      </v-form>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: {
    isSuperUserDashboard: { type: Boolean, default: false },
    isEditMode: { type: Boolean, default: false },
  },
  computed: {
    ...mapGetters(["currentEvent", "businessProfiles", "businessProfile"]),
  },
  data() {
    return {
      requiredRules: [(v) => !!v || "Value is required"],
      isValid: false,
    };
  },
  mounted() {
    this.$emit("validatePage", "AddEditHostDetails", this);
  },
  methods: {
    validatePage() {
      console.log("validate host details page");
      console.log(
        "this.$refs.addEditHostDetailsForm.validate(): ",
        this.$refs.addEditHostDetailsForm.validate()
      );
      return this.$refs.addEditHostDetailsForm.validate();
    },
    handleBusinessProfileChange(businessProfileId) {
      //Get the business name of selected business profile
      let businessProfile = this.businessProfiles.find((businessProfile) => {
        return businessProfileId.trim() == businessProfile.id;
      });
      this.currentEvent.hostName = businessProfile?.businessName || "";
    },
  },
};
</script>

<style>
</style>